import { RefreshCw } from "lucide-react";
import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import DynamicTextEmailRenderer from "./email";
import type { DynamicTextBlockProps } from "./types";

function DynamicTextPlaceholder() {
  return (
    <div className="flex items-start gap-3 rounded-md border border-dashed border-muted-foreground/30 bg-muted/50 px-4 py-3">
      <RefreshCw className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" />
      <div>
        <p className="text-sm font-medium text-muted-foreground">
          Contenu dynamique
        </p>
        <p className="text-xs text-muted-foreground/70">
          Ce texte sera personnalisé pour chaque workflow.
        </p>
      </div>
    </div>
  );
}

export default function DynamicTextEditorRenderer(
  props: DynamicTextBlockProps,
) {
  if (props.editorMode === "workflowCustom") {
    return (
      <EmailComponentWrapper shop={props.shop}>
        <DynamicTextEmailRenderer isEditor {...props} />
      </EmailComponentWrapper>
    );
  }

  return (
    <EmailComponentWrapper shop={props.shop}>
      <DynamicTextPlaceholder />
    </EmailComponentWrapper>
  );
}
